import { render, staticRenderFns } from "./KafkaConfiguration.vue?vue&type=template&id=65532033&"
import script from "./KafkaConfiguration.vue?vue&type=script&lang=ts&"
export * from "./KafkaConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports